export default __webpack_public_path__ + "static/media/client-2.cf279809.png";